import { IGetIndiceReajusteByIdUseCase } from "../../../presentation/useCases/read/get_indice_reajuste_by_id_use_case";
import { IndiceReajuste } from "../../models/indice_reajuste";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetIndiceReajusteByIdUseCase
 */

export class GetIndiceReajusteByIdUseCase implements IGetIndiceReajusteByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getIndiceReajusteById(idIndiceReajuste: number): Promise<IndiceReajuste | null> {
    return await this.repository.getIndiceReajusteById(idIndiceReajuste);

  }
};
